/**
 * @file コンポーネント：検索結果ページ検索条件フィルター ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnGetUrlOperations } from "~/src/functions/common";

// コンポーネントを返す
export const SearchFilter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // フィルターリスト
    const [list, setList] = useState([]);
    useEffect(() => {
        if (
            props.keywordString !== "" ||
            props.surgeonString !== "" ||
            props.tagString !== "" ||
            props.typeString !== ""
        ) {
            let label;
            let url;
            let type;
            let value;
            if (props.typeString !== "") {
                // 術式分類で絞り込み時
                label = localized["Label.Category"];
                type = "category";
                url = fnGetUrlOperations(null, {
                    page: null,
                    type: null,
                    name: null,
                });
                value = props.typeString;
                // 手術分類でも絞り込み時
                if (props.operationNameString !== "") {
                    value +=
                        '<i class="fas fa-chevron-right"></i>' +
                        props.operationNameString;
                }
            } else if (props.surgeonString !== "") {
                // 執刀医で絞り込み時
                label = localized["Label.Surgeon"];
                type = "surgeon";
                url = fnGetUrlOperations(null, { page: null, surgeon: null });
                value = props.surgeonString;
            } else if (props.tagString !== "") {
                // 症例タグで絞り込み時
                label = localized["Label.Tag"];
                type = "tag";
                url = fnGetUrlOperations(null, { page: null, tag: null });
                value = props.tagString;
            } else if (props.keywordString !== "") {
                // キーワードで絞り込み時
                label = localized["Label.Keyword"];
                type = "keyword";
                url = fnGetUrlOperations(null, { page: null, keyword: null });
                value = props.keywordString;
            }
            // フィルターリストにセット
            setList([{ label, type, url, value }]);
        }
    }, [
        props.keywordString,
        props.operationNameString,
        props.surgeonString,
        props.tagString,
        props.typeString,
    ]);

    // Presenterに渡す
    return <Presenter {...props} list={list} />;
};
